module.exports = __webpack_public_path__ + "img/pleading_face.5d7332cf.gif";